import React, { useState } from "react";
import { Lock, AlertCircle, Loader2 } from "lucide-react";
import { adminLogin } from "../api/admin";

const AdminLogin = ({ onLoggedIn }) => {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await adminLogin(password);
      onLoggedIn && onLoggedIn();
    } catch (err) {
      setError(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-shell admin-login-shell">
      <form onSubmit={handleSubmit} className="admin-login-card">
        <div className="admin-login-icon"><Lock size={22} /></div>
        <div className="admin-login-title">Admin Access</div>
        <div className="admin-login-sub">Sign in to edit portfolio content</div>

        <label className="admin-label">Password</label>
        <input
          type="password"
          className="admin-input"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Enter admin password"
          autoFocus
          required
        />

        {error && (
          <div className="admin-error">
            <AlertCircle size={14} /> {error}
          </div>
        )}

        <button type="submit" className="admin-btn-primary" disabled={loading}>
          {loading ? <><Loader2 size={14} className="spin" /> Signing in…</> : "Sign in"}
        </button>

        <a href="/" className="admin-back-link">← Back to site</a>
      </form>
    </div>
  );
};

export default AdminLogin;
